<template>
  <div class="pan-box">
    <div id="viewer">
      <div class="viewer-header">{{ title }}</div>
      <div class="con-close" @click="closePan"><i class="el-icon-close" style="font-size: 20px;color: #C4C6C8;"></i>
      </div>
      <div class="btn-box"><span style="color: #E5EFFC;margin-right: 30px;font-size: 10px;"
          @click="menuShow = !menuShow">编辑</span><span style="color: #E5EFFC;margin-right: 30px;font-size: 10px;"
          @click="propertyData">资产</span><span style="color: #E5EFFC;font-size: 10px;"
          @click="dataShow = !dataShow">数据</span></div>
      <div class="menu-box" v-if="menuShow">
        <div class="menu-tit flex" style="justify-content: space-between;"><span>编辑模式</span><i
            class="el-icon-d-arrow-right" style="cursor: pointer;" @click="closeEdit"></i></div>
        <div class="line"></div>
        <div class="menu-two">页面设置</div>
        <input class="input-data" v-model="titleinp" placeholder="编辑页面标题" />
        <input type="file" id="fileInput" style="margin-top: 15px;">
        <div class="menu-two" style="color: #818181;cursor: pointer;" @click="openFile">上传全景图</div>
        <div class="btn-viewer">确 定</div>
        <div class="line"></div>

        <div class="menu-two flex" style="margin-top: 15px;"><span>添加标注</span></div>
        <div class="input-box" style="margin-top: 5px;">
          <input class="input-data" v-model="poptitle" placeholder="请输入标题" />
        </div>
        <div class="input-box">
          <input class="input-data" v-model="popdescribe" placeholder="请输入描述" />
        </div>

        <div class="input-box">
          <input class="input-data" v-model="popsrc" placeholder="请输入链接" />
        </div>
        <div class="menu-two" style="color: #818181;cursor: pointer;">上传图片</div>
        <div class="menu-two flex" style="margin-top: 5px;"><span>添加数据</span></div>
        <div class="menu-two" style="color: #818181;cursor: pointer;" @click="linkInterface">连接数据接口</div>
        <div class="btn-viewer"><span>删 除</span>&nbsp;&nbsp;&nbsp;&nbsp;<span @click="okMoker">确 定</span></div>
        <div class="line"></div>
      </div>
      <div class="data-content" v-if="dataShow">
        <div class="menu-tit flex" style="justify-content: space-between;"><i class="el-icon-d-arrow-left"
            style="cursor: pointer;"></i></div>
        <div class="line"></div>
        <div class="data-content-box flex">
          <span>温度：{{ environmentData.temp }}℃</span>
        </div>
        <div class="data-content-box flex">
          <span>湿度：{{ environmentData.humd }}%</span>
        </div>
        <div class="data-content-box flex">
          <span>CO2：{{ environmentData.co2 }}ppm</span>
        </div>
        <div class="data-content-box flex">
          <span>VOC：{{ environmentData.voc }}ppm</span>
        </div>
        <div class="data-content-box flex swit">
          <span>灯光1：</span>
          <el-switch v-model="value1" size="mini">
          </el-switch>
        </div>
        <div class="data-content-box flex swit">
          <span>灯光2：</span>
          <el-switch v-model="value2" size="mini">
          </el-switch>
        </div>
        <div class="data-content-box flex swit">
          <span>灯光3：</span>
          <el-switch v-model="value3" size="mini">
          </el-switch>
        </div>
      </div>
      <!-- <div class="property-box">
        <el-table :data="tableData" style="width: 100%" :header-cell-style="{
          background: 'transparent',
          color: '#c7c7c9',  
          border: '1px solid #4e4c4c',
        }" size="mini" height="45vh" class="styleTablePanor">
          <el-table-column prop="name" label="资产名称">
          </el-table-column>
          <el-table-column prop="type" label="资产类型" width="90" align="center">
          </el-table-column>
          <el-table-column prop="number" label="数量" width="90" align="center">
          </el-table-column>
          <el-table-column prop="price" label="单价" width="120" align="center">
          </el-table-column>
          <el-table-column prop="manage" label="管理人" width="150" align="center">
          </el-table-column>
          <el-table-column label="操作 " align="center" width="150">
            <template>
              <i class="el-icon-delete" style="cursor: pointer;"></i>
            </template>
</el-table-column>
</el-table>
</div> -->
    </div>
  </div>
</template>
<script>
import service from '../../../service/leftService.js';
import { Viewer } from 'photo-sphere-viewer'
import { MarkersPlugin } from 'photo-sphere-viewer/dist/plugins/markers'
import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'
import 'photo-sphere-viewer/dist/plugins/markers.css'
export default {
  directives: {
    drag: {
      // 指令的定义  
      bind: function (el, binding, vnode) {
        // 获取到vue实例
        let that = vnode.context;
        let drag_dom = el;
        // 获取到拖拽区
        let drag_handle = el.querySelector(".viewer-header");
        // 鼠标在拖拽区按下时触发拖拽
        drag_handle.onmousedown = (e) => {
          // 按下鼠标时，鼠标相对于被拖拽元素的坐标
          let disX = e.clientX - drag_dom.offsetLeft;
          let disY = e.clientY - drag_dom.offsetTop;

          // 获取容器dom
          let container_dom = that.$refs.container;

          document.onmousemove = (e) => {
            // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
            let left = e.clientX - disX;
            let top = e.clientY - disY;

            // 在容器范围内移动时，被拖拽元素的最大left值
            let leftMax =
              container_dom.offsetLeft +
              (container_dom.clientWidth - drag_dom.clientWidth);

            // 在容器范围内移动时，被拖拽元素的最小left值
            let leftMin = container_dom.offsetLeft + 1; //此处+1为容器的边框1px

            if (left > leftMax) {
              drag_dom.style.left = leftMax + "px";
            } else if (left < leftMin) {
              drag_dom.style.left = leftMin + "px";
            } else {
              drag_dom.style.left = left + "px";
            }

            // 在容器范围内移动时，被拖拽元素的最大left值
            let topMax =
              container_dom.offsetTop +
              (container_dom.clientHeight - drag_dom.clientHeight);

            // 在容器范围内移动时，被拖拽元素的最小left值
            let topMin = container_dom.offsetTop + 1; //此处+1为容器的边框1px

            if (top > topMax) {
              drag_dom.style.top = topMax + "px";
            } else if (top < topMin) {
              drag_dom.style.top = leftMin + "px";
            } else {
              drag_dom.style.top = top + "px";
            }
          };

          document.onmouseup = () => {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      },
    },
  },
  data() {
    return {
      panoramaId:"",
      value1: true,
      value2: true,
      value3: true,
      title: "F2J第五会议室",
      titleinp: '',
      poptitle: '',
      popdescribe: '',
      popsrc: '',
      viewer: '',
      markersPlugin: '',
      imgurl1: require('../../../../static/img/diy/0002.jpg'),
      textarea: "",
      content: '',
      markerId: '',
      markerData: {},
      menuShow: false,
      dataShow: false,
      tableData: [],
      environmentData: {
        temp: '24.36',
        humd: "15.05",
        co2: "365.69",
        voc: "569.36"
      },
      timer: null
    }
  },
  methods: {
    /**
     * @description 确定添加此moker点 
     * @time 2020-09-28 15:05:22  
     */
    okMoker() {
      if (this.markerData) {
        this.markerData.tooltip.content = `<div class="marker-tooltip-container">
                <p class="marker-title">
                  ${this.poptitle}
                </p>
                <p class="marker-description">
                  ${this.popdescribe}
                </p>
              </div>`
        this.markerData.type = "jupm"
        this.markersPlugin.updateMarker(this.markerData)
        // 显示tooltip 
        this.markersPlugin.markers[this.markerData.id].showTooltip()
        this.markerId = ""
        this.$message.success("添加成功")
      }
    },
    closePan() {
      clearInterval(this.timer)
      this.$parent.closePanor()
    },
    addMarker(e, data) {
      // 添加初始标注 具体标注编辑后会更新
      // currentTabIndex 1: 添加标注 2:添加跳转
      if (this.currentTabIndex === 1) {
        // console.log('添加标注')
        const id = `marker${+new Date()}`
        const config = {
          id,
          html: `
            <div class="marker-content-container">
            </div>
          `,
          longitude: data.longitude,
          latitude: data.latitude,
          anchor: 'center center',
          tooltip: {
            // tooltip with custom position 
            content: `
              <div class="marker-tooltip-container">
                <p class="marker-title">
                  暂未输入标题
                </p>
                <p class="marker-description">
                  暂未输入描述
                </p>
              </div>
            `,
            position: 'center top'
          },
          visible: true, // 标注初始显示与否
          type: 'marker',
          status: 1,
          isInitialize: true,
          attachment: {
            type: 'img',
            imgArr: [],
            videoArr: []
          }
          // note: {
          //   type: 'marker', // 添加标注 or 添加跳转
          //   status: 1, // 0 未发布 1发布
          //   // target: '', // 要跳转的全景图
          //   // angle: '', // 角度
          //   // sceneName: '', // 要跳转的场景名称
          //   isInitialize: false // 是否是初始化的值 true表示是初始化 未完成编辑的标注 如果点了取消 需要删除  如果编辑完点了保存 值变为false
          // }
        }
        this.markersPlugin.addMarker(config)
        // 显示 tooltip
        this.markersPlugin.markers[id].showTooltip()

        // 隐藏 tooltip
        //   this.markersPlugin.markers[id].hideTooltip()
        this.currentMarkerId = id
      } else if (this.currentTabIndex === 2) {
        const id = `jump${+new Date()}`
        const config = {
          id,
          html: `
          <div class="jump-container">
            <p class="jump-text">
              暂未选择目标场景
            </p>
            <img class="jump-arrow" src="https://aupup-mall-pub.oss-cn-shenzhen.aliyuncs.com/public/b254e741-96d5-40d9-aabd-853c5a2e332f.png"></img>
          </div>
          `,
          longitude: data.longitude,
          latitude: data.latitude,
          anchor: 'center center',
          type: 'jump',
          target: '',
          angle: '',
          sceneName: '',
          isInitialize: true,
          attachment: {
            type: 'img',
            imgArr: [],
            videoArr: []
          }
          // note: {
          //   type: 'jump', // 添加标注 or 添加跳转
          //   target: '', // 要跳转的全景图
          //   angle: '', // 角度
          //   sceneName: '', // 要跳转的场景名称
          //   isInitialize: false // 是否是初始化的值 true表示是初始化 未完成编辑的标注 如果点了取消 需要删除  如果编辑完点了保存 值变为false
          // }
        }
        this.markersPlugin.addMarker(config)
        this.currentMarkerId = id
      }
    },
    test() {
      alert('test')
    },
    createViwe() {
      let id = '123'
      this.viewer = new Viewer({
        container: document.querySelector('#viewer'),
        panorama: this.imgurl1,
        fisheye: false,
        autorotateIdle: true,
        defaultZoomLvl: 50,
        size: {
          width: '50vw',
          height: '50vh',
          defaultZoomLvl: 0
        },
        navbar: false, //导航栏显示与隐藏那  
        plugins: [
          [MarkersPlugin, {
            markers: [
              /* {
                id: '123',
                tooltip: `<div>温度：24.31℃</div><div>湿度：17.04%</div><div>CO2：1498ppm</div><div>VOC：1040ppm</div>`,
                circle: 5,
                svgStyle: {
                  fill: '#76D1FC',
                  stroke: '#ffffff00',
                  strokeWidth: '20px',
                },
                type: 'jump',
                isInitialize: true,
                longitude: -0.07,
                latitude: 0.1,
                anchor: 'center right',
                title: "图片test",
                clickEventOnMarker: true,
              }, */
              {
                // 自定义样式的标记
                id: "text",
                longitude: 3.28,
                latitude: 0,
                // html: "HTML <b>marker</b> &hearts;", // 显示内容
                html:
                  "<div class='textWrap' ><div id='text1' style='padding:5px;background:#0000008e'>会议大屏</div> </div>", // 显示内容
                anchor: "bottom right",
                scale: [0.5, 1.5],
                style: {
                  // maxWidth: "100px",
                  color: "white",
                  fontSize: "20px",
                  fontFamily: "Helvetica, sans-serif",
                  textAlign: "center"
                },
                tooltip: ''
              },
              {
                // 自定义样式的标记
                id: "text4",
                longitude: 3.08,
                latitude: 0.54,
                // html: "HTML <b>marker</b> &hearts;", // 显示内容
                html:
                  `<div class='textWrap' ><div id='text1' style='color:#05BDF1'>29.10℃</div></div>`, // 显示内容  
                anchor: "bottom right",
                scale: [0.5, 1.5],
                style: {
                  // maxWidth: "100px", 
                  color: "white",
                  fontSize: "20px",
                  fontFamily: "Helvetica, sans-serif",
                  textAlign: "center"
                },
                tooltip: ''
              },

              {
                // 自定义样式的标记
                id: "text2",
                longitude: 3.67,
                latitude: 0.48,
                // html: "HTML <b>marker</b> &hearts;", // 显示内容
                html:
                  "<div class='textWrap' ><div id='text1' style='color:#05BDF1'>30.30℃</div></div>", // 显示内容
                anchor: "bottom right",
                scale: [0.5, 1.5],
                style: {
                  // maxWidth: "100px",
                  color: "white",
                  fontSize: "20px",
                  fontFamily: "Helvetica, sans-serif",
                  textAlign: "center"
                },
                tooltip: ''
              },
              {
                // 自定义样式的标记
                id: "text5",
                longitude: 2.3,
                latitude: 0.37,
                // html: "HTML <b>marker</b> &hearts;", // 显示内容
                html:
                  "<div class='textWrap' ><div id='text1' style='color:#05BDF1'>42.75℃</div></div>", // 显示内容
                anchor: "bottom right",
                scale: [0.5, 1.5],
                style: {
                  // maxWidth: "100px",
                  color: "white",
                  fontSize: "20px",
                  fontFamily: "Helvetica, sans-serif",
                  textAlign: "center"
                },
                tooltip: ''
              },
              {
                // 自定义样式的标记
                id: "text3",
                longitude: 4.25,
                latitude: 0.27,
                // html: "HTML <b>marker</b> &hearts;", // 显示内容
                html:
                  "<div class='textWrap' ><div id='text1' style='color:#05BDF1'>40.12℃</div></div>", // 显示内容
                anchor: "bottom right",
                scale: [0.5, 1.5],
                style: {
                  // maxWidth: "100px",
                  color: "white",
                  fontSize: "20px",
                  fontFamily: "Helvetica, sans-serif",
                  textAlign: "center"
                },
                tooltip: ''
              },
              {
                // 自定义样式的标记
                id: "text6",
                longitude: -0.07,
                latitude: 0.22,
                // html: "HTML <b>marker</b> &hearts;", // 显示内容
                html:
                  "<div class='textWrap' ><div id='text1' style='color:#05BDF1'>28.4℃</div></div>", // 显示内容
                anchor: "bottom right",
                scale: [0.5, 1.5],
                style: {
                  // maxWidth: "100px",
                  color: "white",
                  fontSize: "20px",
                  fontFamily: "Helvetica, sans-serif",
                  textAlign: "center"
                },
                tooltip: ''
              },
              {
                // 自定义样式的标记
                id: "text7",
                longitude: -0.47,
                latitude: 0.19,
                // html: "HTML <b>marker</b> &hearts;", // 显示内容
                html:
                  "<div class='textWrap' ><div id='text1' style='color:#05BDF1'>41.55℃</div></div>", // 显示内容
                anchor: "bottom right",
                scale: [0.5, 1.5],
                style: {
                  // maxWidth: "100px",
                  color: "white",
                  fontSize: "20px",
                  fontFamily: "Helvetica, sans-serif",
                  textAlign: "center"
                },
                tooltip: ''
              },
              {
                // 自定义样式的标记
                id: "text8",
                longitude: 0.18,
                latitude: 0.23,
                // html: "HTML <b>marker</b> &hearts;", // 显示内容
                html:
                  "<div class='textWrap' ><div id='text1' style='color:#05BDF1'>28.50℃</div></div>", // 显示内容
                anchor: "bottom right",
                scale: [0.5, 1.5],
                style: {
                  // maxWidth: "100px",
                  color: "white",
                  fontSize: "20px",
                  fontFamily: "Helvetica, sans-serif",
                  textAlign: "center"
                },
                tooltip: ''
              },
              {
                // 自定义样式的标记
                id: "text9",
                longitude: 0.63,
                latitude: 0.20,
                // html: "HTML <b>marker</b> &hearts;", // 显示内容
                html:
                  "<div class='textWrap' ><div id='text1' style='color:#05BDF1'>42.12℃</div></div>", // 显示内容
                anchor: "bottom right",
                scale: [0.5, 1.5],
                style: {
                  // maxWidth: "100px",
                  color: "white",
                  fontSize: "20px",
                  fontFamily: "Helvetica, sans-serif",
                  textAlign: "center"
                },
                tooltip: ''
              },
              {
                // 自定义样式的标记
                id: "text10",
                longitude: -0.3,
                latitude: 0.10,
                // html: "HTML <b>marker</b> &hearts;", // 显示内容
                html:
                  "<div class='textWrap' ><div id='text1' style='color:#05BDF1'>31.77℃</div></div>", // 显示内容
                anchor: "bottom right",
                scale: [0.5, 1.5],
                style: {
                  // maxWidth: "100px",
                  color: "white",
                  fontSize: "20px",
                  fontFamily: "Helvetica, sans-serif",
                  textAlign: "center"
                },
                tooltip: ''
              },
              {
                // 自定义样式的标记
                id: "text11",
                longitude: 0,
                latitude: 0.12,
                // html: "HTML <b>marker</b> &hearts;", // 显示内容
                html:
                  "<div class='textWrap' ><div id='text1' style='color:#05BDF1'>26.70℃</div></div>", // 显示内容
                anchor: "bottom right",
                scale: [0.5, 1.5],
                style: {
                  // maxWidth: "100px",
                  color: "white",
                  fontSize: "20px",
                  fontFamily: "Helvetica, sans-serif",
                  textAlign: "center"
                },
                tooltip: ''
              },
              {
                // 自定义样式的标记
                id: "text12",
                longitude: 0.17,
                latitude: 0.12,
                // html: "HTML <b>marker</b> &hearts;", // 显示内容
                html:
                  "<div class='textWrap' ><div id='text1' style='color:#05BDF1'>28.40℃</div></div>", // 显示内容
                anchor: "bottom right",
                scale: [0.5, 1.5],
                style: {
                  // maxWidth: "100px",
                  color: "white",
                  fontSize: "20px",
                  fontFamily: "Helvetica, sans-serif",
                  textAlign: "center"
                },
                tooltip: ''
              },
              {
                // 自定义样式的标记
                id: "text13",
                longitude: 0.43,
                latitude: 0.12,
                // html: "HTML <b>marker</b> &hearts;", // 显示内容
                html:
                  "<div class='textWrap' ><div id='text1' style='color:#05BDF1'>41.77℃</div></div>", // 显示内容
                anchor: "bottom right",
                scale: [0.5, 1.5],
                style: {
                  // maxWidth: "100px",
                  color: "white",
                  fontSize: "20px",
                  fontFamily: "Helvetica, sans-serif",
                  textAlign: "center"
                },
                tooltip: ''
              },
              {
                // 自定义样式的标记
                id: "text14",
                longitude: 0.5,
                latitude: 0.9,
                // html: "HTML <b>marker</b> &hearts;", // 显示内容
                html:
                  "<div class='textWrap' ><div id='text1' style='color:#05BDF1'>30.60℃</div></div>", // 显示内容
                anchor: "bottom right",
                scale: [0.5, 1.5],
                style: {
                  // maxWidth: "100px",
                  color: "white",
                  fontSize: "20px",
                  fontFamily: "Helvetica, sans-serif",
                  textAlign: "center"
                },
                tooltip: ''
              },
              {
                // 自定义样式的标记
                id: "text15",
                longitude: -0.65,
                latitude: 0.75,
                // html: "HTML <b>marker</b> &hearts;", // 显示内容
                html:
                  "<div class='textWrap' ><div id='text1' style='color:#05BDF1'>32.40℃</div></div>", // 显示内容
                anchor: "bottom right",
                scale: [0.5, 1.5],
                style: {
                  // maxWidth: "100px",
                  color: "white",
                  fontSize: "20px",
                  fontFamily: "Helvetica, sans-serif",
                  textAlign: "center"
                },
                tooltip: ''
              },
              {
                // 自定义样式的标记
                id: "text16",
                longitude: -1.2,
                latitude: 0.33,
                // html: "HTML <b>marker</b> &hearts;", // 显示内容
                html:
                  "<div class='textWrap' ><div id='text1' style='color:#05BDF1'>39.22℃</div></div>", // 显示内容
                anchor: "bottom right",
                scale: [0.5, 1.5],
                style: {
                  // maxWidth: "100px",
                  color: "white",
                  fontSize: "20px",
                  fontFamily: "Helvetica, sans-serif",
                  textAlign: "center"
                },
                tooltip: ''
              },
              {
                // 自定义样式的标记
                id: "text17",
                longitude: 1.35,
                latitude: 0.4,
                // html: "HTML <b>marker</b> &hearts;", // 显示内容
                html:
                  "<div class='textWrap' ><div id='text1' style='color:#05BDF1'>40.37℃</div></div>", // 显示内容
                anchor: "bottom right",
                scale: [0.5, 1.5],
                style: {
                  // maxWidth: "100px",
                  color: "white",
                  fontSize: "20px",
                  fontFamily: "Helvetica, sans-serif",
                  textAlign: "center"
                },
                tooltip: ''
              },
              {
                // 自定义样式的标记
                id: "text18",
                longitude: -2,
                latitude: 0.88,
                // html: "HTML <b>marker</b> &hearts;", // 显示内容
                html:
                  "<div class='textWrap' ><div id='text1' style='color:#05BDF1'>25.50℃</div></div>", // 显示内容
                anchor: "bottom right",
                scale: [0.5, 1.5],
                style: {
                  // maxWidth: "100px",
                  color: "white",
                  fontSize: "20px",
                  fontFamily: "Helvetica, sans-serif",
                  textAlign: "center"
                },
                tooltip: ''
              },
              /* { 
                id: '001',
                tooltip: ``, 
                circle: 8, 
                svgStyle: {
                  fill: 'rgb(0, 94, 255)',
                  stroke: '#fff',
                  strokeWidth: '1px', 
                },
                longitude: 3.5, 
                latitude: 0.1, 
                anchor: 'center right',
                title: "摄像机",
                className: 'makeTest'
              }, */
              /* {
                id: 'circle1',
                tooltip: `<div>温度：24.31℃</div><div>湿度：17.04%</div><div>CO2：1498ppm</div><div>VOC：1040ppm</div>`,
                svgStyle: {
                  fill: '#76D1FC',
                  stroke: '#ffffff00',
                  strokeWidth: '20px',
                },
                html: `
          <div class="jump-container">
            <p class="jump-text">
            </p>
            <img class="jump-arrow" src="https://aupup-mall-pub.oss-cn-shenzhen.aliyuncs.com/public/b254e741-96d5-40d9-aabd-853c5a2e332f.png" style=' width: 50px;height: 40px;transform: rotate(-90deg);'></img>
          </div>
          `,
                longitude: -0.7,
                latitude: -0.3,
                anchor: 'center center',
                type: 'jump',
                target: '',
                angle: '',
                sceneName: '',
                isInitialize: true,
                attachment: {
                  type: 'img',
                  imgArr: [],
                  videoArr: []
                }
              } */
            ],
          }],
        ],
      });
      this.markersPlugin = this.viewer.getPlugin(MarkersPlugin)
      this.markersPlugin.on('select-marker', this.clickMarker)
      this.viewer.once('ready', () => {
        // 去掉首屏loading
        this.fullLoading = false
        // 初始化标注
        // this.initMarkers()
        // 自动水平旋转
        // this.viewer.startAutorotate()
      })
      this.viewer.on('zoom-updated', (e, level) => {
        console.log(`new zoom level is ${level}`);
        if (level == '0') {
          this.dataShow = true
        } else {
          this.dataShow = false
        }
      });
    },
    switchImg() {
      this.imgurl1 = require('../../../../static/img/diy/000.jpg')
      // 清除图片
      this.viewer.destroy()
      this.createViwe()
    },
    switchImgTwo() {
      this.imgurl1 = require('../../../../static/img/diy/011.jpg')
      // 清除图片 
      this.viewer.destroy()
      this.createViwe()
    },
    /**
     * @description: 点击marker点后的跳转
     */
    clickMarker(e, marker) {
      console.log('点击的marker点', marker)
      let _this = this
      /* if (marker.id === 'circle1') {
        this.title = '办公区'  
        this.imgurl1 = require('../../../../static/img/diy/022.jpg')
        // 清除图片 
        this.viewer.destroy()
        this.createViwe()
        setTimeout(() => {
          _this.markersPlugin = this.viewer.getPlugin(MarkersPlugin)
          _this.markersPlugin.clearMarkers()
          _this.markersPlugin.addMarker({
            id: '002',
            html: `
          <div class="jump-container">
            <p class="jump-text">
            </p>
            <img class="jump-arrow" src="https://aupup-mall-pub.oss-cn-shenzhen.aliyuncs.com/public/b254e741-96d5-40d9-aabd-853c5a2e332f.png" style=' width: 50px;height: 40px;transform: rotate(90deg);'></img>
          </div>
          `,
            longitude: 2.7,
            latitude: -0.3,
            anchor: 'center center',
            type: 'jump',
            target: '',
            angle: '',
            sceneName: '',
            isInitialize: true,
            attachment: {
              type: 'img',
              imgArr: [],
              videoArr: []
            }
          })
        }, 1000)
      } else {
        this.title = '会议室'
        this.imgurl1 = require('../../../../static/img/diy/011.jpg')
        // 清除图片 
        this.viewer.destroy()
        this.createViwe()
        this.selectMarker()
      } */
    },
    /**
     * 编辑模式选取maker点
     */
    selectMarker() {
      this.viewer.on('click', (e, data) => {
        console.log(e)
        console.log('marker:', data)
        // 如果没有确定需要将上次的moker点进行清楚
        if (this.markerId) {
          // 清除moker点 
          this.markersPlugin.removeMarker(this.markerId)
        }
        this.markerId = `mark${Math.random() * 10}`
        let config = {
          id: this.markerId,
          tooltip: {
            content: `
               <div class="marker-tooltip-container">
                 <p class="marker-title">
                   暂未输入标题
                 </p>
                 <p class="marker-description">
                   暂未输入描述
                 </p>
               </div>
             `,
            position: 'center top'
          },
          circle: 8,
          svgStyle: {
            fill: '#6fa5de',
            stroke: '#6fa5de',
            strokeWidth: '1px',
          },
          longitude: data.longitude,
          latitude: data.latitude,
          anchor: 'center right',
          title: "图片test",
          className: 'makeTest',
          type: '',
        }
        this.markerData = config
        this.markersPlugin.addMarker(config)
      })
    },
    /**
     * 编辑模式下保存或者修改marker点位
     * 
     */
    updateMarker() {

    },
    /**
     * 开启编辑模式
     */
    openEdit() {
      this.menuShow = true
    },
    /**
     * 关闭编辑模式
     */
    closeEdit() {
      this.menuShow = false
    },
    /**
     * 资产数据框
     */
    propertyData() {

    },
    /**获取数据接口 */
    getData() {
      let obj = {
        args: ['F2J第五会议室环境数据接口']
      }
      service.getPublicData2(obj).then(res => {
        res.forEach(item => {
          if (item.name == "AIR_Temp") {
            this.environmentData.temp = item.value
          }
          if (item.name == "AIR_Humd") {
            this.environmentData.humd = item.value
          }
          if (item.name == "AIR_CO2") {
            this.environmentData.co2 = item.value
          }
          if (item.name == "AIR_VOC") {
            this.environmentData.voc = item.value
          }
        })
      })
    },
    /**
     * 连接数据接口
     */
    linkInterface() {
      alert("连接数据接口")
    },
    /**
     * 删除marker点位
     */
    deleteMarker(val) {
      this.markersPlugin.removeMarker(val.id)
      this.isEditMarker = false
    },
    /**
     * 查询所有全景图
     */
    queryAllPanorama() {
      service.getAllPanorama().then(res => {

      })
    },
    // 点击上传全景图按钮
    openFile() {
      var fileInput = document.getElementById('fileInput');
      var file = fileInput.files[0];
      let arr = ["F2J第五会议室环境数据接口", "F2J第五会议室环境数据接口"]
      let formData = new FormData();
      formData.append('file', file);
      formData.append('name', file.name);
      formData.append('dataInterface', arr);
      service.addPanorama(formData).then(res => {
        console.log(res)
      }).catch(err => {
        this.$message.error("服务器错误，上传失败")
      })
    },
  },
  mounted() {
    this.queryAllPanorama()
    this.createViwe()
    this.selectMarker()
    this.timer = setInterval(() => {
      this.getData()
    }, 2000)
    //this.markersPlugin = this.viewer.getPlugin(MarkersPlugin) 
    /* this.markersPlugin.on('select-marker', this.clickMarker) */
  }
}
</script>
<style scoped>
.swit>>>.el-switch__core {
  width: 30px !important;
  height: 14px;
}

.swit>>>.el-switch__core:after {
  width: 13px;
  height: 13px;
  top: 0;
}

.swit>>>.el-switch.is-checked .el-switch__core:after {
  margin-left: -13px !important;
}

.jump-arrow {
  width: 50px;
  height: 50px;
}


#viewer {
  padding: 0px 0px 0px 0px;
  box-shadow: 0px 0px 8px #A3CBF2;
  border: 1px solid #6fa5de;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}

.viewer-header {
  width: 100%;
  height: 25px;
  position: absolute;
  z-index: 99;
  top: 0;
  background-image: url('../../../../static/img/diy/009.png');
  background-size: 100% 100%;
  text-align: center;
  line-height: 22px;
  color: #e5effc;
  font-size: 15px;
}

.pan-box {
  position: relative;
  z-index: 999;
  top: 20%;
  left: 25%;
}

.con-close {
  position: absolute;
  width: 30px;
  height: 30px;
  z-index: 99;
  right: 1%;
  top: 0;
  padding: 5px;
  cursor: pointer;
}

.btn-box {
  width: 100%;
  height: 25px;
  position: absolute;
  z-index: 99;
  bottom: 0;
  cursor: pointer;
  background-image: url('../../../../static/img/diy/010.png');
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 5px;
}

.menu-box {
  width: 150px;
  height: 100%;
  position: absolute;
  z-index: 100;
  right: 0;
  background: #2c3243df;
  backdrop-filter: blur(7px);
  -webkit-backdrop-filter: blur(7px);
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-sizing: border-box;
  padding: 5px 5px 0px 5px;
}

.data-content {
  width: 150px;
  height: 100%;
  position: absolute;
  z-index: 100;
  left: 0;
  background: #3434349c;
  box-sizing: border-box;
  padding: 10px 5px 0px 5px;
}

.menu-tit {
  width: 100%;
  color: #E7E7EA;
  font-size: 13px;
  font-weight: 800;
  margin-left: 5px;
  padding: 0px 5px 0px 0px;
}

.line {
  width: 100%;
  height: 1px;
  background-color: #5f5f5f;
}

.menu-two {
  color: #E7E7EA;
  margin-top: 10px;
  font-size: 13px;
  margin-left: 5px;
  margin-bottom: 5px;
}

.input-box {
  width: 99%;
  height: 18px;
  margin-top: 10px;
}

.input-data {
  width: 100%;
  height: 20px;
  background-color: transparent;
  color: #e6e6e6cb;
  text-align: left;
  border: 1px solid #9b9b9ba2;
  padding-left: 5px;
  font-size: 9px;
}

.input-data:focus {
  outline: none;
  border: 1px solid #9b9b9ba2;
}

.input-data::-webkit-input-placeholder {
  /* WebKit browsers */
  color: rgba(138, 138, 138, 0.796);
  font-size: 9px;
}

.input-data:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: rgba(138, 138, 138, 0.796);
  font-size: 9px;
}

.input-data::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: rgba(138, 138, 138, 0.796);
  font-size: 9px;
}

.input-data:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: rgba(138, 138, 138, 0.796);
  font-size: 9px;
}

.btn-viewer {
  width: 96%;
  text-align: right;
  color: #76D1FC;
  cursor: pointer;
  font-size: 12px;
}

.flex {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.data-content-box {
  width: 100%;
  color: #76D1FC;
  box-sizing: border-box;
  padding: 5px;
  font-size: 13px;
}

.property-box {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 999;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(9px);
  -webkit-backdrop-filter: blur(9px);
}

.property-box>>>.el-table,
.el-table__expanded-cell {
  background-color: transparent !important;
}

.property-box>>>.el-table tr {
  background-color: transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/components/graphically/GCBIG/panorama.vue